import { hasCookie } from 'cookies-next';
import { IncomingMessage, ServerResponse } from 'http';

const isLoggedIn = (req: IncomingMessage, res: ServerResponse): boolean => {
  return hasCookie('showroom_backend_session_' + process.env.RELEASE_STAGE, { req, res });
};

export default isLoggedIn;
